// extracted by mini-css-extract-plugin
export var container = "styles-module--container--c8822";
export var header = "styles-module--header--1dd5d";
export var tag = "styles-module--tag--08516";
export var tagGrey = "styles-module--tagGrey--d5f86";
export var tagLilac = "styles-module--tagLilac--a826b";
export var tags = "styles-module--tags--f3de2";